import { ChevronDown } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import type React from "react";
import { XStack } from "tamagui";
import { useUserSelectSheet } from "../../../../core/components/UserSelectSheet";
import { useStores } from "../../../../core/stores";
import { Body } from "../../../../ui/Body";
import { Label } from "../../../../ui/Label";
import { UserAvatar } from "../../../../ui/UserAvatar";
import type { ExpenseFormState } from "./ExpenseFormState";

export const AddExpenseFormPaidBy: React.FC<{
  formState: ExpenseFormState;
}> = observer(({ formState }) => {
  const { usersStore } = useStores();

  const user = usersStore.byId.get(formState.paidByUserId);
  const { setOpen, UserSelectSheet } = useUserSelectSheet(
    (value) => formState.setPaidByUserId(value),
    formState.paidByUserId,
  );

  return (
    <>
      <XStack
        padding="$large"
        backgroundColor={"$backgroundBlock"}
        justifyContent="space-between"
        alignItems="center"
        onPress={() => setOpen(true)}
      >
        <XStack gap={"$medium"} alignItems="center">
          <Label>Paid by</Label>
          {user ? (
            <XStack gap={"$medium"} alignItems="center">
              <UserAvatar userUid={user.uid} />
              <Body>{user.data.displayName}</Body>
            </XStack>
          ) : (
            <Body muted>Select user</Body>
          )}
        </XStack>
        <ChevronDown />
      </XStack>
      <UserSelectSheet />
    </>
  );
});
